import React from 'react';

import { DatePicker, Form, FormItemProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

interface Props {
  startWeek?: Dayjs | string;
  formItemsProps: FormItemProps;
}

export function WeekPicker({ startWeek, formItemsProps }: Props) {
  return (
    <Form.Item
      {...formItemsProps}
    >
      <DatePicker
        picker="week"
        disabledDate={(current) => current && current < dayjs(startWeek).startOf('week').add(1, 'week')}
      />
    </Form.Item>
  );
}

